import { SerpStoreChangeSnapshot } from '@/components/Approval/@components/SerpStoreChange';
import { parseSerpContent } from '@/utils/approval/serpDocument';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 162 SERP 매장 변경 — 저장 content 그대로(레거시 조회와 동일) */
const SerpStoreChangeSlot = ({ data }: ContentExtraProps) => {
  const content = parseSerpContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SerpStoreChangeSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SerpStoreChangeSlot;
